// TODO: this has been copied wholesale from the Component Library project.
// Perhaps we can find a way to surface it as an export?

import tokens from '@vaad1st/shared.design-tokens/json/variables.json';
import { useEffect, useState } from 'react';

export enum BreakPointToken {
  LgMax = tokens.breakpoint_max_screen_lg.value,
  LgMin = tokens.breakpoint_min_screen_lg.value,
  MdMax = tokens.breakpoint_max_screen_md.value,
  MdMin = tokens.breakpoint_min_screen_md.value,
  SmMax = tokens.breakpoint_max_screen_sm.value,
  SmMin = tokens.breakpoint_min_screen_sm.value,
}

const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => {
      setMatches(media.matches);
    };
    media.addListener(listener);
    return () => media.removeListener(listener);
  }, [matches, query]);

  return matches;
};

export default useMediaQuery;
